<template>
  <div :class="['select-by-type', extraClasses]">
    <h5 class="data-title text-center">
      {{textBeforeSelected}}
      <span :class="['selected-data-type', openClose]"
            @click="showDataTypeList = !showDataTypeList">
        {{selectedType}}
      </span>
      {{textAfterSelected}}
    </h5>

    <clickable-list
        :listItems="dataTypes"
        :openClose="openClose"
        separator="|"
        @clickAction="setSelectedDataType">
    </clickable-list>
  </div>
</template>

<script>
  import ClickableList from '../shared/ClickableList'

  export default {
    props: {
      customDataTypes: Array,
      customSelected: String,
      extraClasses: String,
      initSelected: {
        default: 'spend',
        type: String,
      },
      textAfterSelected: String,
      textBeforeSelected: {
        default: 'by:',
        type: String,
      },
    },

    name: 'SelectByType',

    components: {
      ClickableList,
    },

    data() {
      return {
        dataTypes: ['spend', 'visits'],
        selectedDataType: null,
        showDataTypeList: false,
      }
    },

    methods: {
      setSelectedDataType(dataType) {
        if (dataType && this.selectedDataType !== dataType) {
          this.selectedDataType = dataType
          this.$emit('setDataType', dataType)
          setTimeout(() => this.showDataTypeList = false, 500)
        }
      },
    },

    created() {
      if (this.customDataTypes) { this.dataTypes = this.customDataTypes }
      this.selectedDataType = this.initSelected
    },

    computed: {
      openClose: function() {
        return this.showDataTypeList ? 'open' : 'close'
      },

      selectedType: function() {
        return this.customSelected ? this.customSelected : this.selectedDataType
      },
    },
  }
</script>